"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UsersError = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _lodash = _interopRequireDefault(require("lodash"));
var _error = require("./error");
var _basic = _interopRequireDefault(require("./_basic"));
class UsersError extends _error.BasicError {
  /**
   * @constructor
   */
  constructor(error, data) {
    super('Users API Error', error, data);
  }
}
exports.UsersError = UsersError;
class UsersApi extends _basic.default {
  /**
   * @constructor
   */
  constructor(_ref) {
    let {
      userTokenFactory,
      sdkApiUrl,
      accountId
    } = _ref;
    super({
      userTokenFactory
    });
    this.sdkApiUrl = sdkApiUrl;
    this.accountId = accountId;
    this.axios = this._createAxios();
  }
  async getUsers() {
    let {
      projection,
      chunked,
      limit,
      last
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return await this._callApi({
      method: 'get',
      queryParams: {
        projection,
        chunked,
        limit,
        last
      }
    });
  }
  async getUserById(userId, projection) {
    return await this._callApi({
      method: 'get',
      path: `/${encodeURIComponent(userId)}`,
      queryParams: {
        projection
      },
      errorData: {
        userId
      }
    });
  }
  async getUserByUserName(username) {
    return await this._callApi({
      method: 'get',
      path: `${this.sdkApiUrl}/users/username/${encodeURIComponent(username)}`,
      errorData: {
        username
      }
    });
  }
  async getUserByEmail(email) {
    return await this._callApi({
      method: 'get',
      path: `${this.sdkApiUrl}/users/email/${encodeURIComponent(email)}`,
      errorData: {
        email
      }
    });
  }

  /**
   * 
   * @param {String} user.role role of new user
   * @param {String} user.accountId accountId of new user
   * @param {String} user.email email of multi user   
   * @returns {Object} {emailSent: true/undefined, userCreated: true/undefined} userCreated - if multi user exists. if not it will send verification email and create only after comfirmation 
   */
  async createUserWithMulti(user) {
    return await this._callApi({
      method: 'post',
      path: `${this.sdkApiUrl}/accounts/${this.accountId}/multi-user/create-start`,
      payload: user
    });
  }
  async createUser(user) {
    return await this._callApi({
      method: 'post',
      payload: user
    });
  }
  async enableUser(user) {
    return await this._callApi({
      method: 'put',
      path: `/${encodeURIComponent(user.id)}/enable`,
      errorData: {
        userId: user.id
      }
    });
  }
  async disableUser(user) {
    return await this._callApi({
      method: 'put',
      path: `/${encodeURIComponent(user.id)}/disable`,
      errorData: {
        userId: user.id
      }
    });
  }
  async deleteUser(user) {
    return await this._callApi({
      method: 'delete',
      path: `/${encodeURIComponent(user.id)}`,
      errorData: {
        userId: user.id
      }
    });
  }
  /**
   * 
   * @param {String} email of multi user
   * @param {String} userId if of user to attach to multi user
   * @param {String} password SUPER_ADMIN only. when multi user not exists, it will create multi user without email verification
   * @returns {Object} {userAttached: true/undefined, emailSent: true/indefined} userAttached true - if multi user exists, if multi user not exists, it sends verification email and after verificaton user will be created
   */
  async attachUser(email, userId, password) {
    return this._callApi({
      method: 'post',
      path: `${this.sdkApiUrl}/accounts/${this.accountId}/multi-user/attach-start`,
      payload: {
        email,
        userId,
        password
      }
    });
  }
  /**
   * @param {String} email email of multi user
   * @returns {Object} {id, email,username} or 404
   */
  async getMultiUser(email) {
    return this._callApi({
      method: 'get',
      path: `${this.sdkApiUrl}/multi-user/${encodeURIComponent(email)}`
    });
  }
  /**
   * 
   * @param {String} param0.email email of multi user
   * @param {String} param0.password password of multi user 
   * @returns {Object} {id, email,username}
   */
  async createMultiUser(_ref2) {
    let {
      email,
      password
    } = _ref2;
    return this._callApi({
      method: 'put',
      path: `${this.sdkApiUrl}/multi-user/create`,
      payload: {
        email,
        password
      }
    });
  }
  async updateUser(_ref3) {
    let {
      userId,
      user
    } = _ref3;
    return await this._callApi({
      method: 'put',
      path: `/${encodeURIComponent(userId)}`,
      payload: _lodash.default.pick(user, ['data', 'email', 'username', 'role', 'multiUserId']),
      errorData: {
        userId
      }
    });
  }
  async setUserRole(_ref4) {
    let {
      userId,
      role
    } = _ref4;
    return await this._callApi({
      method: 'put',
      path: `/${encodeURIComponent(userId)}/role`,
      payload: {
        role
      },
      errorData: {
        userId,
        role
      }
    });
  }
  async getUserData(_ref5) {
    let {
      userId,
      key
    } = _ref5;
    const keyPath = key ? `/${encodeURIComponent(key)}` : '';
    const path = `/${encodeURIComponent(userId)}/user-data${keyPath}`;
    return await this._callApi({
      method: 'get',
      path,
      errorData: {
        userId
      }
    });
  }
  async setUserData(_ref6) {
    let {
      userId,
      key,
      value
    } = _ref6;
    const keyPath = key ? `/${encodeURIComponent(key)}` : '';
    const path = `/${encodeURIComponent(userId)}/user-data${keyPath}`;
    return await this._callApi({
      method: 'post',
      path,
      payload: value,
      errorData: {
        userId
      }
    });
  }
  async _callApi(_ref7) {
    let {
      method,
      path = '',
      payload,
      queryParams,
      errorData = {}
    } = _ref7;
    const {
      headers
    } = await this.getHeaders();
    try {
      const {
        data: responseBody
      } = await this.axios({
        method,
        url: path,
        data: JSON.stringify(payload),
        params: queryParams,
        headers
      });
      return responseBody;
    } catch (error) {
      throw new UsersError(error, {
        statusCode: _lodash.default.get(error, 'response.status'),
        ...errorData,
        errorResponse: _lodash.default.get(error, 'response.data')
      });
    }
  }
  _createAxios() {
    let {
      baseUrl
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const usersUrl = `${this.sdkApiUrl}${this.accountId ? `/accounts/${encodeURIComponent(this.accountId)}` : ''}/users`;
    return _axios.default.create({
      baseURL: baseUrl || usersUrl
      // timeout : 10000
    });
  }

  async getMultiUserEmails(_ref8) {
    let {
      emailPart
    } = _ref8;
    const {
      emails
    } = await this._callApi({
      path: `${this.sdkApiUrl}/multi-user/autocomplete/${emailPart}`,
      method: 'get'
    });
    return emails;
  }
  async getMultiUserProfile(_ref9) {
    let {
      id
    } = _ref9;
    return this._callApi({
      path: `${this.sdkApiUrl}/multi-user/profile/${id}`,
      method: 'get'
    });
  }
}
var _default = UsersApi;
exports.default = _default;